const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

const ADMIN = {
    DASHBOARD: `${API_BASE_URL}/admin/dashboard/`,
    USERS: `${API_BASE_URL}/admin/users/`,
    CATEGORIES_LIST: `${API_BASE_URL}/admin/categories/`,
    CREATE_CATEGORY: `${API_BASE_URL}/admin/categories/create/`,
    DELETE_CATEGORY: `${API_BASE_URL}/admin/categories/delete/`,
    PROFESSIONS_LIST: `${API_BASE_URL}/admin/professions/`,
    PROFESSIONS_CREATE: `${API_BASE_URL}/admin/professions/create/`,
    PLATFORM_SERVICES_LIST: `${API_BASE_URL}/admin/all-platform-services/`,
    PLATFORM_SERVICE_CREATE: `${API_BASE_URL}/admin/platform-services/create/`,
};

export default ADMIN;